import React from 'react';
import styled, { keyframes } from 'styled-components';


// Define keyframes for animations
const bubbleAnimation = keyframes`
  0% {
    transform: scale(0.15, 0.15);
    top: 80%;
    opacity: 0;
  }
  50% {
    transform: scale(1.1, 1.1);
    opacity: 1;
  }
  100% {
    transform: scale(0.33, 0.33);
    top: 60%;
    opacity: 0;
  }
`;

const pulseAnimation = keyframes`
  0% {
    transform: scale(1, 1);
    opacity: 0.25;
  }
  50% {
    transform: scale(1.2, 1);
    opacity: 1;
  }
  100% {
    transform: scale(1, 1);
    opacity: 0.25;
  }
`;

// Styled components for the cooking animation
const Container = styled.div`
  background-color: #F0F3F5;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
`;

const Header = styled.h1`
  position: relative;
  margin: 0 auto;
  top: 25vh;
  width: 100vw;
  text-align: center;
  font-family: "Amatic SC";
  font-size: 6vh;
  color: #339E79;
  opacity: 0.75;
  animation: ${pulseAnimation} 2.5s linear infinite;
`;

const CookingArea = styled.div`
  position: relative;
  margin: 0 auto;
  top: 0;
  width: 75vh;
  height: 75vh;
  overflow: hidden;
`;

const Bubble = styled.div`
  position: absolute;
  border-radius: 100%;
  box-shadow: 0 0 0.25vh lighten(#333, 10%);
  opacity: 0;

  &:nth-child(1) {
    margin-top: 2.5vh;
    left: 58%;
    width: 2.5vh;
    height: 2.5vh;
    background-color: lighten(#333, 7%);
    animation: ${bubbleAnimation} 2s cubic-bezier(0.53, 0.16, 0.39, 0.96) infinite;
  }

  /* Add other bubble styles here */
`;

const CookingAnimation = () => {
  return (
    <Container>
      <Header>Page in Under Development ..</Header>
      <CookingArea>
        {[...Array(5)].map((_, index) => (
          <Bubble key={index} className="bubble" />
        ))}
        {/* Add other cooking elements here */}
      </CookingArea>
    </Container>
  );
};

export default CookingAnimation;
